<template>
  <!--
    This wrapper is required to:
    1) Ensure the external styles are applied correctly
    2) Prevent a bug when <a-visibility> renders the lazy
    hydrated component even when it should be hidden
  -->
  <div class="top-brokers-with-refresh__wrapper">
    <a-top-brokers
      :key="
        $_lazyHydratedComponentState_getHydratedComponentRefreshKey(
          $options.consts.HYDRATED_SECTION_NAME
        )
      "
      :sidebar-layout="sidebarLayout"
      :top-brokers="topBrokers"
      @mounted="onMounted"
    />
  </div>
</template>

<script>
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'
import { RERENDER_TOP_BROKERS_COMPONENT_BUS_NAME } from '@/utils/enums/top-brokers'
import mixins from '@/utils/mixins'
import { PROP_TYPES, propValidator } from '@/utils/validators'
import { mapGetters } from 'vuex'

const HYDRATED_SECTION_NAME = 'TOP_BROKERS'

export default {
  name: 'TobBrokersWithDelayedRefresh',
  mixins: [mixins.lazyHydratedComponentState],
  components: {
    ATopBrokers: hydrateWhenVisible(() => import('shared/ATopBrokers'), {
      props: ['sidebar-layout', 'top-brokers']
    })
  },
  props: {
    sidebarLayout: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  consts: {
    HYDRATED_SECTION_NAME
  },
  computed: {
    ...mapGetters({
      topBrokers: 'layouts/topBrokers'
    })
  },
  methods: {
    rerenderSectionOnUpdate() {
      this.$_lazyHydratedComponentState_rerenderNonHydratedComponents([
        HYDRATED_SECTION_NAME
      ])
    },
    onMounted() {
      this.$_lazyHydratedComponentState_onHydratedComponentMounted(
        this.$options.consts.HYDRATED_SECTION_NAME
      )
    }
  },
  beforeMount() {
    this.$bus.$on(
      RERENDER_TOP_BROKERS_COMPONENT_BUS_NAME,
      this.rerenderSectionOnUpdate
    )
  },
  beforeDestroy() {
    this.$bus.$off(
      RERENDER_TOP_BROKERS_COMPONENT_BUS_NAME,
      this.rerenderSectionOnUpdate
    )
  }
}
</script>
